var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 py-1 px-3 body-2"},[_c('v-row',{staticStyle:{"min-height":"40px"},attrs:{"no-gutters":"","align":"center"}},[_vm._t("default",null,{"object":_vm.object,"to":_vm.to,"index":_vm.index})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }